import React from 'react';
import NoItemsPage from '../../../components/NoItemsPage';
import { Button, withStyles } from '@material-ui/core';
import Typography from '@material-ui/core/Typography';

const styles = {
  paragraph: {
    width: '100%',
    margin: 0,
    marginBottom: '12px',
    color: 'rgba(33,35,34,0.5)',
    fontSize: '13px',
    fontWeight: 400
  },
  step: {
    color: 'rgba(33,35,34,0.5)',
    fontSize: '13px',
    fontWeight: 400,
    marginBottom: 34,
    textAlign: 'left',
    width: '100%',
    paddingLeft: 40,
    '&:not(:last-of-type)': {
      marginBottom: 8
    }
  }
}

const NoWebsitesPage =  ({classes}) => <NoItemsPage
  title="Welcome! Let’s add your first domain">
  <Typography className={classes.paragraph} variant="body1">
    Start collecting consent from your website visitors with a cookie pop-up in just two easy steps:
  </Typography>
  <Typography variant="body1" className={classes.step}>1. Add your domain so our scanner can find cookies on your website</Typography>
  <Typography variant="body1" className={classes.step}>2. Add the cookie pop-up to your website</Typography>
  <Button color="secondary"
          variant="contained"
          href="#/websites/create"
          style={{fontWeight:500}}>
    ADD YOUR FIRST DOMAIN
  </Button>
</NoItemsPage>

export default withStyles(styles)(NoWebsitesPage);
